import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import Icon from 'components/Icon';

const DELIVERY_TYPES = {
    BOPIS: 'bopis',
    GIS: 'gis'
    // FER-420: SDD: 'sdd'
};

const getEmptyStateCopyKeys = deliveryType => {
    if (deliveryType === DELIVERY_TYPES.BOPIS) {
        return { prefixKey: 'bopisEmptyStatePrefix', boldKey: 'bopisEmptyStateBold' };
    }

    return { prefixKey: 'gisEmptyStatePrefix', boldKey: 'gisEmptyStateBold' };
};

/**
 * Renders a tappable prompt when a fulfillment location is not set.
 * Shows localized copy with a bold suffix and a caret icon.
 * Tapping the button triggers the store or zip code selection modal.
 */
const EmptyStatePrompt = ({ onClick, getText, deliveryType }) => {
    const { prefixKey, boldKey } = getEmptyStateCopyKeys(deliveryType);

    return (
        <Text
            is='button'
            type='button'
            lineHeight='tight'
            fontSize='sm'
            onClick={onClick}
        >
            {getText(prefixKey)}
            <Text
                is='span'
                fontWeight='bold'
                children={getText(boldKey)}
            />
            <Icon
                name='caretDown'
                size={12}
                marginLeft={1}
            />
        </Text>
    );
};

EmptyStatePrompt.propTypes = {
    onClick: PropTypes.func.isRequired,
    getText: PropTypes.func.isRequired,
    // FER-420: add DELIVERY_TYPES.SDD when Same Day Delivery is implemented
    deliveryType: PropTypes.oneOf([DELIVERY_TYPES.BOPIS, DELIVERY_TYPES.GIS]).isRequired
};

export default wrapFunctionalComponent(EmptyStatePrompt, 'EmptyStatePrompt');
